/**
 * WISHLIST LIST SHARE
 * 
 * module pour le partage de wishlist
 * via un formulaire
 */
import $ from "jquery";
import { dialog } from "../../../../components/dialog.js";
const utils = require('../utils.js').default;

const WLListShare = (() => {
    const FSW_DEFAULT_NAME = 'liste partagée';
    const FSW_FORM = 'form#partage-wishlit';
    const POPIN_IMPORT_SHARE_LIST_NOT_ALLOWED = 'popin-import-share-list-not-allowed';
    const DOM_POPIN_IMPORT_SHARE_LIST_NOT_ALLOWED = `[data-js-dialog-id="${POPIN_IMPORT_SHARE_LIST_NOT_ALLOWED}"]`;
    const POPIN_IMPORT_SHARE_LIST_NOT_SUCCESS = 'popin-import-share-list-success';
    const DOM_POPIN_IMPORT_SHARE_LIST_NOT_SUCCESS = `[data-js-dialog-id="${POPIN_IMPORT_SHARE_LIST_NOT_SUCCESS}"]`;
    
    let defaultNameId = 0;
    let wlName = '';

    /**
     * ADD SHARE PRODUCTS
     * 
     * @param {object} data 
     */
    const addShareProducts = (data) => {
        let ids = [];
        data.datas.elements.forEach(element => {
            ids.push(parseInt(element.ean));
        });
        window.WL.addToWishlist(ids, wlName, 'pro');
    };
    const cleanUrl = () => {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        params.delete('wishlist');
        const nextURL = `${window.location.pathname}?${params.toString()}`;
        const nextTitle = document.title;
        const nextState = { additionalInformation: 'Updated the URL with JS' };
        window.history.replaceState(nextState, nextTitle, nextURL);
        // window.location.href = `${window.location.pathname}?${params.toString()}`;
    };
    /**
     * CREATE SHARE WISHLIST
     * 
     * création d'un liste partagé.
     * Si elle existe on incrémente le
     * nom par défaut
     */
    const createShareWishlist = (wlName) => {
        return new Promise (function(resolve, reject) {
            window.WL.createWishlist(wlName, 'pro').then(() => {
                resolve();
            })
        });
    };
    /**
     * GET SHARE WISHLIST NAME ALLOWED
     */
    const getShareWishlistNameAllowed = (wlName) => {
        if (window.WL.isWishlistExist(wlName, 'pro')) {
            // existe on reste avec un autre name
            defaultNameId++;
            return getShareWishlistNameAllowed(`${FSW_DEFAULT_NAME} ${defaultNameId}`);
        } else {
            return wlName;
        }
    };
    /**
     * LOAD SHARED WISHLIST
     * 
     * chargement d'une wishlist share via un service
     * une fois load, la WL est ajoutée au listes
     * @returns 
     */
    const loadSharedWishlist = () => {
        // chargement de la shared WL
        if (!utils.getQueryVariable('wishlist')) return;
        let wlID = utils.slug(decodeURI(utils.getQueryVariable('wishlist')));
        window.WL.loadProductsFromIds([], wlID).then((data) => {
        // window.WL.loadProductsFromIds([3414971437661,3292290503010]).then((data) => {
            if (utils.userLogged()){
                // creation et ajout de la nouvelle WL
                wlName = getShareWishlistNameAllowed(FSW_DEFAULT_NAME);
                utils.dispatchCustomEvent('TTRACKER_LOAD_SHARE_WISHLIST', {name: wlName});
                createShareWishlist(wlName).then(() => {
                    // création OK
                    addShareProducts(data);
                    cleanUrl();
                    popinOpen();
                }).catch(() => {
                    // création not OK - on recréer avec un nouveau nom
                })
            } else {
                // affichage d'une popin demandant la connexion
                // pour accéder à la fonctionnalité
                dialog.open(POPIN_IMPORT_SHARE_LIST_NOT_ALLOWED);
            }
        }).catch((error) => {
            utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
        })
    };
    const popinOpen = () => {
        updateTemplates();
        dialog.open(POPIN_IMPORT_SHARE_LIST_NOT_SUCCESS);
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     * @param {*} event 
     */
    const updateTemplates = (event) => {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        params.append('wishlistid', utils.slug(wlName));
        const nextURL = `${window.location.pathname}?${params.toString()}`;
        let data = {
            name: wlName,
            url: nextURL,
        };        
        utils.linksObfuscation();
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: POPIN_IMPORT_SHARE_LIST_NOT_SUCCESS, data});
    };
    /**
     * INIT (func)
     */
    const init = () => {
        if ($(FSW_FORM).length === 0) return;
        window.WL.loadAllWishlists().then(() => {
            utils.debug('WL FORM SHARE', 'initialisation');   
            WL.setCurrentWishlist(utils.getWishlistId());
            $(`${FSW_FORM} #wishlit-name`).val(window.WL.getWishlistName());
            $(`${FSW_FORM} #wishlit-context`).val(utils.getContext());
            $(`${FSW_FORM} #wishlit-reduction`).val(window.WL.getWishlistReduction());
            $(`${FSW_FORM} #wishlit-ids`).val(window.WL.getWishlistListFlatten().join(','));
        });
    };
    return {
        loadSharedWishlist,
        init
    }
})();
export default WLListShare;